import { render, staticRenderFns } from "./DonutChart48.vue?vue&type=template&id=7938c2e9&scoped=true"
import script from "./DonutChart48.vue?vue&type=script&lang=js"
export * from "./DonutChart48.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938c2e9",
  null
  
)

export default component.exports